import React, { useState } from 'react';
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { FaFileExport } from 'react-icons/fa';
import globalHandleError from '../../api/apiErrorHandle';
import { downloadData } from '../../utils/downloadData';
import { XLSX_MIME_TYPE } from '../../services/excel/constants';

interface Props {
  label: string;
  fileName: string;
  onExport: () => Promise<Blob>;
}

export default function CommissionPricelistExport({
  label, fileName, onExport,
}: Readonly<Props>) {
  const [exporting, setExporting] = useState(false);

  async function handleExport(): Promise<void> {
    setExporting(true);
    try {
      const pricelist = await onExport();
      downloadData(pricelist, XLSX_MIME_TYPE, fileName);
    } catch (error) {
      globalHandleError(error);
    } finally {
      setExporting(false);
    }
  }

  return (
    <IconButton
      style={{ width: 220 }}
      appearance="primary"
      icon={<Icon as={FaFileExport} />}
      placement="right"
      loading={exporting}
      onClick={() => handleExport()}
    >
      {label}
    </IconButton>
  );
}
